import React, { useState } from 'react'
import { SpinLoading } from 'antd-mobile'
import { statusLabel } from '../utils/bridgeFormat'
import BridgeSetDetailModal from '../WorkoutDetails/BridgeSetDetailModal'
import '../styles/BridgeCard.css'

const StatusPill = ({ status }) => {
  if (!status) return <span className="bridge-status-pill default">—</span>
  const cls =
    status === 'completed'
      ? 'bridge-status-pill completed'
      : 'bridge-status-pill inprogress'
  return <span className={cls}>{statusLabel(status)}</span>
}

const SetCard = ({ record, onSelect }) => (
  <div className="bridge-set-card">
    <div
      className="bridge-set-card-header"
      onClick={() => onSelect(record)}
    >
      <div className="bridge-set-card-main">
        <p className="bridge-set-title">{record.workout_name || 'Workout'}</p>
        <p className="bridge-set-subtitle">
          {record.exercise_name || '—'}
          {record.phase_name ? ` · ${record.phase_name}` : ''}
        </p>
      </div>
      <div className="bridge-set-card-right">
        <StatusPill status={record.status} />
        <span className="bridge-chevron">›</span>
      </div>
    </div>
  </div>
)

export default function BridgeCard({ records, loading, error }) {
  const [selectedRecord, setSelectedRecord] = useState(null)

  if (loading) {
    return (
      <div className="bridge-loading">
        <SpinLoading color="default" /> Loading Bridge data...
      </div>
    )
  }

  if (error) {
    return (
      <p className="bridge-no-data">Failed to load Bridge data. Please try again later.</p>
    )
  }

  if (!records || records.length === 0) {
    return (
      <div className="bridge-empty-card">
        <p className="bridge-no-data">No Bridge workout sets for this day.</p>
      </div>
    )
  }

  return (
    <div>
      {records.map((record) => (
        <SetCard
          key={record.id ?? `${record.date_time}-${record.sequence}`}
          record={record}
          onSelect={setSelectedRecord}
        />
      ))}

      <BridgeSetDetailModal
        visible={!!selectedRecord}
        onClose={() => setSelectedRecord(null)}
        record={selectedRecord}
      />
    </div>
  )
}
